import { useQuery } from '@tanstack/react-query'
import { healthApi } from '@/lib/client'

export const useHealthStatistics = () => {
    return useQuery({
        queryKey: ['health', 'statistics', 'yearly'],
        queryFn: () => healthApi.getStatistikYearly(),
        staleTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
    })
}

export default useHealthStatistics
